const config = {
    APP_ENV: 'alpha',
    API: 'https://api.alpha.trainheroic.com',
    URL_COACHHEROIC: 'https://coach.alpha.trainheroic.com/admin/coach#',
    URL_MARKETPLACE: 'https://marketplace.alpha.trainheroic.com',
    URL_COACHAPP: 'https://coachapp.alpha.trainheroic.com/',
    URL_SUPPORT: 'https://support.trainheroic.com/hc/en-us',
    URL_PRICING: 'https://www.trainheroic.com/pricing/',
    URL_THANKS: 'https://www.trainheroic.com/thanks/',
    LOGIN: 'https://marketplace.alpha.trainheroic.com/account/login',
    GARMIN_SSO_LOGOUT_URL:
        'https://ssotest.garmin.com/portal/sso/en-US/logout?clientId=TRAINHEROIC&service=https://auth.alpha.trainheroic.com',
    REDUX_LOGGER_ENABLED: true,
    ROLLBAR_ENV: 'account-alpha',
    SESSION_NAME: 'alpha-Session',
    SEGMENT_KEY: 'uFEHdDNIYi0n8LsmpK1RzFdtEqsMEwMF',
    AMBASSADOR_ID: '734a3122-d8cf-4c83-88b6-93407a46887b'
};

export default config;
